import { render } from "./basket_product_details.vue?vue&type=template&id=4a34eb7e"
import script from "./basket_product_details.vue?vue&type=script&lang=js"
export * from "./basket_product_details.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__